<template>
  <f7-page>
    <f7-navbar title="Dynamic Route" sliding></f7-navbar>
<f7-preloader size="25px"></f7-preloader>
    <f7-list media-list id="search-list">
      <f7-list-item v-for="e in exams" :key="e.id"
        :title="e.id"
      >
      </f7-list-item>
    </f7-list>

    <!-- <f7-block inner>
      <ul>
        <li><b>Url:</b> {{$route.url}}</li>
        <li><b>Path:</b> {{$route.path}}</li>
        <li><b>Hash:</b> {{$route.hash}}</li>
        <li><b>Params:</b>
          <ul>
            <li v-for="(value, key) in $route.params"><b>{{key}}:</b> {{value}}</li>
          </ul>
        </li>
        <li><b>Query:</b>
          <ul>
            <li v-for="(value, key) in $route.query"><b>{{key}}:</b> {{value}}</li>
          </ul>
        </li>
        <li><b>Route:</b> {{$route.route.path}}</li>
      </ul>
    </f7-block>
    <f7-block inner>
      <f7-link @click="$route.view.router.back()">Go back via Router API</f7-link>
    </f7-block> -->

  </f7-page>
</template>

<script>
import Settings from '../settings'

const apiurl = 'http://' + Settings.host + ':6161/api'

export default {
  data () {
    return {
      exams: []
    }
  },
  created () {
    var vm = this

    vm.$http.get(apiurl + '/patients/' + vm.$route.params.patientId).then(response => {
      vm.exams = response.body.data

      console.log(vm.exams)
    }, response => {

    })
  },
  methods: {
    onSearch (query, found) {
      console.log('HAVABAA')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/ExamList.vue